import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType, SlotsType } from 'vue'

export const pagetableColumnButtongroupProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  tail: [Boolean, String],
})

export type PagetableColumnButtongroupProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnButtongroupProps>>>

export default defineComponent({
  name: 'OPagetableColumnButtongroup',
  inheritAttrs: false,
  props: pagetableColumnButtongroupProps(),
  slots: Object as SlotsType<{
    default: any
  }>,
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
